// Your web app's Firebase configuration

import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

var firebaseConfig = {
    apiKey: "AIzaSyCg64m7JS2yOBz6I8i4Oy62jIO7u4nca_Q",
    authDomain: "photogram-8b6f1.firebaseapp.com",
    projectId: "photogram-8b6f1",
    storageBucket: "photogram-8b6f1.appspot.com",
    messagingSenderId: "563494543142",
    appId: "1:563494543142:web:59c30711e87de87ef32be7"
};
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };